<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <hamburger
      v-if="this.show"
      :is-active="sidebar.opened"
      @toggleClick="toggleSideBar"
    />
    <img
      v-if="!this.show"
      :src="logo"
      :class="logo ? 'sidebar-logo1' : 'sidebar-logo'"
      style="height: 60px; width: 100%"
    />
    <!-- <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img v-if="logo" :src="logo" class="sidebar-logo" />
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo" />
      </router-link>
    </transition> -->
  </div>
</template>

<script>
import Logo from "@/assets/images/logo.png";
import Logo1 from "@/assets/imagesHK/logo.png";
import Logo2 from "@/assets/imagesMINI/logo.png";
import Logo3 from "@/assets/imagesOlar/logo.png";
import Hamburger from "@/components/Hamburger";
import { mapGetters } from "vuex";
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["sidebar"]),
  },
  components: {
    Hamburger,
  },
  mounted() {
    console.log(
      process.env.VUE_APP_API_BASE_NAME,
      "process.env.VUE_APP_API_BASE_NAME"
    );
    this.IsPC();
    if (process.env.VUE_APP_API_BASE_NAME == "hk") {
      this.logo = Logo1;
    } else if (process.env.VUE_APP_API_BASE_NAME == "ja") {
      this.logo = Logo;
    } else if (process.env.VUE_APP_API_BASE_NAME == "mini") {
      this.logo = Logo2;
      this.mini = true;
      console.log(this.logo, " this.logo");
    } else if (process.env.VUE_APP_API_BASE_NAME == "olar") {
      this.logo = Logo3;
    }
  },
  data() {
    return {
      title: "RECYCLE",
      logo: Logo,
      show: false,
      mini: false,
    };
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    IsPC() {
      let userAgent = navigator.userAgent.toLowerCase();
      // 用 test 匹配浏览器信息
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          userAgent
        )
      ) {
        this.mobile = false;
        this.show = false;
        // console.log("前端是移动端");
      } else {
        this.mobile = true;
        this.show = true;
        // console.log("前端是pc端");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 8s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  // background-color: red;
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }
  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
.sidebar-logo1 {
  height: 50px !important;
}
</style>
